<template>
  <div class="watch">
    <div class="watch_head">
      <ul>
        <li
          v-for="(tab, index) in tabsCard.tabs"
          :key="index"
          :class="{ active: tabsCard.num === index }"
          @click="tab(index)"
        >
          <span>{{ tab }}</span>
        </li>
      </ul>
      <div class="barSty" v-if="isEdit">
        <span style="margin-right: 10px" @click="cancelEdit(false)">取消</span>
        <span @click="cancelEdit(true)">删除</span>
      </div>
      <span v-else @click="changeEditStatus">编辑</span>
    </div>
    <div class="main">
      <div>
        <el-checkbox-group v-model="checkList">
          <div class="itemCard" v-for="(item, index) in showData" :key="index">
            <div class="card">
              <img
                v-if="item.videoInfo"
                :src="item.videoInfo.horizontalImage"
                alt=""
                @click="jumpToVideo(item.videoInfo.status, item.videoInfo.id)"
              />
              <img v-else src="/img/no_data.043dd92a.png" alt="" />
              <span v-if="type === 'watch' && item.remainingTime">剩余 {{ formatTime(item.remainingTime) }}</span>
              <span v-if="(type === 'collect' || type === 'download') && item.duration">时长 {{ formatTime(item.duration) }}</span>
              <div class="layer" v-show="isEdit">
                <el-checkbox :label="item.id"></el-checkbox>
              </div>
            </div>
            <div class="cardDes">
              <p>{{ item.videoInfo ? item.videoInfo.videoName : '' }}</p>
              <p>第{{ item.episode }}集</p>
            </div>
          </div>
        </el-checkbox-group>
      </div>
      <div class="no-data" v-if="isShowNoContent">
        <img src="/img/no_data.043dd92a.png" alt="" style="width: 200px" />
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'

export default {
  name: 'HistoryList',
  props: {
    type: { type: String, default: 'watch' } // watch | collect | download
  },
  data() {
    return {
      tabsCard: { tabs: ['电影', '电视剧', '娱乐生活', '全部'], num: 0 },
      isEdit: false,
      isShowNoContent: false,
      checkList: [],
      showData: []
    }
  },
  mounted() {
    this.tab(0)
  },
  methods: {
    formatTime(t) {
      if (!t) return ''
      if (typeof t === 'string' && t.length >= 8) return t.slice(0, 8)
      const total = Math.floor(+t)
      const h = Math.floor(total / 3600)
      const m = Math.floor((total % 3600) / 60)
      const s = total % 60
      const pad = v => (v < 10 ? '0' + v : v)
      return `${pad(h)}:${pad(m)}:${pad(s)}`
    },
    tab(index) {
      this.tabsCard.num = index
      let categoryId
      if (index === 0) categoryId = 1
      else if (index === 1) categoryId = 3
      else if (index === 2) categoryId = 2
      else categoryId = ''
      this.fetchData(categoryId)
    },
    fetchData(categoryId) {
      if (this.type === 'download') {
        this.fetchUploadData(categoryId)
      } else {
        const historyType = this.type === 'watch' ? 1 : 2
        this.$axios({
          method: 'get',
          url: '/realNet/history/getHistories',
          headers: { token: getToken() },
          params: { type: historyType, categoryId }
        }).then(res => {
          const content = res.data.result.content || []
          this.showData = content
          this.isShowNoContent = content.length === 0
        })
      }
    },
    fetchUploadData(categoryId) {
      const params = {
        'videoInfo.categoryId': 4,
        'videoInfo.shareCategoryIds': categoryId,
        orderByType: 'DESC',
        pageSize: 21
      }
      this.$axios({
        method: 'get',
        url: '/realNet/download/getDownloads',
        headers: { token: getToken() },
        params
      }).then(res => {
        const content = res.data.result.content || []
        this.showData = content
        this.isShowNoContent = content.length === 0
      })
    },
    changeEditStatus() {
      this.isEdit = true
    },
    cancelEdit(isDel) {
      if (isDel) {
        if (this.checkList.length === 0) {
          this.$message.warning('请选择要删除的数据')
          return
        }
        this.delCollect()
      } else {
        this.isEdit = false
        this.checkList = []
      }
    },
    delCollect() {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'delete',
          url: '/realNet/history/delete',
          headers: { token: getToken() },
          data: { historyIds: this.checkList.join(',') }
        }).then(() => {
          this.$message({ showClose: true, message: '删除成功', type: 'success', duration: 1000 })
          this.isEdit = false
          this.checkList = []
          this.tab(this.tabsCard.num)
        })
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' })
      })
    },
    jumpToVideo(status, id) {
      if (status === 1) {
        this.$router.push({ path: '/tvplay-page', query: { contentId: id } })
      } else if (status === 2) {
        this.$message.warning('此视频已下架，请观看其他视频')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.watch {
  width: 930px;

  .watch_head {
    width: 100%;
    height: 41px;
    border: 1px solid #eaeced;
    padding: 0 40px;
    margin-bottom: 30px;
    background-color: #f9f9f9;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ul {
      width: 70%;
      height: 100%;
      padding: 0;
      display: flex;

      li {
        height: 100%;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        position: relative;
        list-style: none;

        span { cursor: pointer; }

        &.active {
          font-weight: 700;

          &::before {
            position: absolute;
            left: 50%;
            margin-left: -15px;
            bottom: -2px;
            content: "";
            background-color: #3bc0d0;
            width: 35px;
            height: 3px;
          }
        }
      }
    }

    .barSty,
    > span {
      font-size: 14px;
      color: #2cb5c5;
      cursor: pointer;
    }
  }

  .main {
    width: 100%;

    .itemCard {
      width: 290px;
      height: 190px;
      margin: 0 18px 40px 0;
      display: inline-block;

      .card {
        width: 290px;
        height: 165px;
        margin-bottom: 10px;
        background-color: #ccc;
        position: relative;

        img {
          width: 290px;
          height: 165px;
          cursor: pointer;
        }

        > span {
          position: absolute;
          right: 10px;
          bottom: 10px;
          padding: 2px 10px;
          font-size: 14px;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.65);
          border-radius: 12px;
          text-align: center;
        }

        .layer {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 10;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.3);
        }
      }

      .cardDes {
        display: flex;
        justify-content: space-between;
        padding: 0 6px;
        font-size: 14px;
      }
    }
  }

  .no-data {
    text-align: center;
  }
}
</style>
